import { I18n } from 'react-redux-i18n'
import { removeAccents } from '../../../../helpers/common'
import { changeValueWithDot, valByKeyWithDot } from '../../../../helpers/value'
import { MAIN_SCREEN, SCREEN } from '../../constant'
import {
  COMPARE_INDUSTRY,
  DEFAULT_INDUSTRY,
} from '../../helper/companyAnalysis/industryAnalysis'

export const jsonToString = (obj) => JSON.stringify(obj || {})

export const getCount = (panelId, panelById) => {
  const count = {}
  panelId.forEach((id) => {
    const { screen = '', panel = '', type = '', mainScreen } = panelById[id]
    const value = count[`${screen}_${panel}_${type}`]
    count[`${screen}_${panel}_${type}`] = !value ? 1 : value + 1
    if (mainScreen) {
      count[mainScreen] = !count[mainScreen] ? 1 : count[mainScreen] + 1
    }
  })
  return count
}

export const copyObj = (obj) => JSON.parse(JSON.stringify(obj))

export const convertItemsPdf = (panelId, panelById) => {
  return panelId.map((id) => {
    const item = copyObj(panelById[id])
    if (!item.title || !item.title.trim()) {
      if (typeof item.label === 'object') {
        item.title = I18n.t(item.label.text)
        item.subTitle = I18n.t(item.label.subText)
      } else {
        item.title = I18n.t(item.label)
      }
    }
    if (item.setting?.isHasNote && item.setting?.note?.trim()) {
      item.note = item.setting?.note?.trim()
    }
    return item
  })
}

export const handlePortfolioData = (payload) => {
  return payload.map((item) => ({
    ...item,
    label: item.portfolioName,
    value: item.portfolioId,
  }))
}

export const filterDropList = (dropList, inputValue) => {
  if (!dropList.length) return []
  const val = removeAccents(inputValue.trim().toLowerCase())

  return dropList.filter((item) => {
    const label = removeAccents(item.label.toLowerCase())
    return label.includes(val)
  })
}

export const getLabelAndValuePortfolio = (
  portfolioByRedirect,
  allPortfolio,
) => {
  const { name, id } = portfolioByRedirect
  let label = name
  let value = id

  if (!label) {
    label = allPortfolio.find((item) => item.value === value)?.label || ''
  }

  if (!value) {
    value = allPortfolio.find((item) => item.label === label)?.value
  }

  return { label, value }
}

export const convertParamSettingFs = (data = []) => {
  if (!data.length) {
    return {}
  }

  const years = []
  const methods = []
  const auditStatuses = []
  let isConsolidated = true
  let sourceOrganizationId = ''

  data.forEach((item) => {
    auditStatuses.push({ year: item.year, isAudit: item.audited })
    methods.push({ year: item.year, isDirect: item.isDirect })
    years.push(item.year)
    isConsolidated = item.consolidated
    sourceOrganizationId = item.sourceOrganizationId
  })

  return {
    sourceOrganizationId,
    isConsolidated,
    years,
    methods,
    auditStatuses,
  }
}

const keyAsync = {
  [SCREEN[MAIN_SCREEN.PORTFOLIO_INSIGHT].FINANCE]: [
    '1.selectValue',
    '2.selectValue',
    '1.isChecked',
    '2.isChecked',
  ],
  [SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS]: [
    DEFAULT_INDUSTRY,
    COMPARE_INDUSTRY,
  ],
}

export const changeValueAllPanel = (panelById, panel) => {
  const keys = keyAsync[panel.screen]

  if (!keys) {
    return
  }

  const values = keys.map((key) =>
    valByKeyWithDot(panel.setting || {}, key, true),
  )

  Object.keys(panelById).forEach((id) => {
    if (panelById[id].screen === panel.screen) {
      keys.forEach(
        (key, index) =>
          (panelById[id].setting = changeValueWithDot(
            panelById[id].setting || {},
            key,
            values[index],
          )),
      )
    }
  })
}
